<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit additional comments</cll-dialog-title>
        <cll-dialog-subtitle>For {{ client.reference }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">chat</cll-icon>
            <span class="dialog-container-header-text">Additional comments</span>
        </div>
        <div>
            <cll-form-field>
                <textarea cllFormInput
                          [formControl]="personDetailsFormGroup.controls.additional_comments"></textarea>
            </cll-form-field>
            <cll-form-field-hint>
                Optional
            </cll-form-field-hint>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (this.updateClientRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-outline-button (click)="reset()" [disabled]="!personDetailsFormGroup.dirty" appearance="outline" colour="variant">
            Reset
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="personDetailsFormGroup.invalid || this.updateClientRequest.loading()"
                (click)="update()">
            Save
        </button>

    </cll-dialog-footer>
</cll-dialog-layout>
